import PropTypes from 'prop-types';

import React from 'react';
import { Map } from 'immutable';
import { connect } from 'react-redux';

import { mergeBlockData } from '../EditorContainer/actions';
import { spellCheckBlock } from '../SpellCheck/actions';

import BlockControls from '../../components/BlockControls';
import SpellCheckButton from '../../components/BlockControls/SpellCheckButton';

export class BlockControlsContainer extends React.PureComponent {
  static propTypes = {
    block: PropTypes.instanceOf(Map).isRequired,
    readOnly: PropTypes.bool,

    onRemove: PropTypes.func,
    mergeBlockData: PropTypes.func,
    spellCheckBlock: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this._handlers = {
      onClickRemove: this.showDeleteModal,
      onClickSpellCheck: this.handleClickSpellCheck,
      onClickConfirmRemove: this.handleClickConfirmRemove,
      onClickDismissRemoveModal: this.hideRemoveModal,
      onMergeBlockData: this.handleMergeBlockData,
    };

    this.handleMergeBlockData = this._buildHandler('onMergeBlockData');
    this.handleClickSpellCheck = this._buildHandler('onClickSpellCheck');
    this.handleClickRemove = this._buildHandler('onClickRemove');
    this.handleClickConfirmRemove = this._buildHandler('onClickConfirmRemove');
    this.handleClickDismissRemoveModal = this._buildHandler(
      'onClickDismissRemoveModal'
    );

    this.state = {
      showDeleteConfirmation: false,
    };
  }

  get buttons() {
    const buttons = [];

    const spellCheckButton = (
      <SpellCheckButton
        key="SpellCheckButton"
        onClick={this.handleClickSpellCheck}
      />
    );

    switch (this.props.block.get('type')) {
      case 'TEXT':
      case 'COLLAPSE':
      case 'QUOTE':
      case 'IMAGE':
      case 'VIDEO':
        buttons.push(spellCheckButton);
        break;
      default:
        break;
    }

    return buttons;
  }

  _buildHandler =
    (eventName) =>
    (...args) => {
      if (!this.props.readOnly) {
        const method = this._handlers[eventName];
        if (method) {
          method(...args);
        }
      }
    };

  handleMergeBlockData = (data) => {
    this.props.mergeBlockData(this.props.block.get('key'), data);
  };

  handleClickSpellCheck = () => {
    this.props.spellCheckBlock(this.props.block.get('key'));
  };

  showDeleteModal = () => {
    this.setState({ showDeleteConfirmation: true });
  };

  hideRemoveModal = () => {
    setTimeout(() => {
      this.setState({ showDeleteConfirmation: false });
    }, 0);
  };

  handleClickConfirmRemove = () => {
    this.props.onRemove(this.props.block.get('key'));
  };

  render() {
    return (
      <BlockControls
        blockType={this.props.block.get('type')}
        blockButtons={this.buttons}
        showDeleteConfirmation={this.state.showDeleteConfirmation}
        onClickRemove={this.handleClickRemove}
        onClickConfirmRemove={this.handleClickConfirmRemove}
        onClickDismissRemoveModal={this.handleClickDismissRemoveModal}
      />
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    mergeBlockData: (blockKey, data) => {
      dispatch(mergeBlockData(blockKey, data));
    },
    spellCheckBlock: (blockKey) => {
      dispatch(spellCheckBlock(blockKey));
    },
  };
}

export default connect(null, mapDispatchToProps)(BlockControlsContainer);
